module.exports = __webpack_public_path__ + "img/Graph.2c078f7b.png";